import React from 'react'
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';


const Container = styled.div`

min-height:300px;
display:flex;
align-items:center;
flex-direction:column;
text-align:center;
`
const Title = styled.div`

padding-top:40px;
font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;
`
const Subtitle = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;

`
const SVGContainer = styled.div`
    padding-top:10px
`;

const ActionsFormEmptyStateV2 = ({title = "",subtitle = "", showSVG = false}) => {
    
    return(
        <Container>

            <>
            <Title>
                {title}
            </Title>

            <Subtitle>
                {subtitle}
            </Subtitle>
            
            {showSVG && 
                <SVGContainer>
                    <img width="100px" src="../icons/Empty-State_search-list.svg"/>
                </SVGContainer>
            }
            
            </>
            
        </Container>
    );


}


export default ActionsFormEmptyStateV2;